define(['jquery', 'jquery.history'], function ($) {
    var manualStateChange = true;
    var sString = 2;
    var queryString = window.location.hash;
    if (queryString == "") {
        queryString = window.location.search;
        sString = 1;
    }
    var keyword;
    if (queryString != undefined && queryString.indexOf("keyword") > -1) {

        queryString = queryString.substring(sString);
        var params = queryString.split("&");
        var tab;
        for (i = 0; i < params.length; i++) {
            if (params[i].indexOf("keyword") > -1) {
                var temp = params[i].split("=");
                keyword = decodeURI(temp[1]);
                $(".search-form #search").val(keyword);

            }

        }
    }
    (function (window, undefined) {
        // Define variables
        var History = window.History,
        State = History.getState();

        // Bind statechange event
        History.Adapter.bind(window, 'statechange', function () {
            var State = History.getState();

        });

    })(window)


    $(".search-form #searchPage").click(function () {
        var url = [location.protocol, '//', location.host, location.pathname].join('');
        var term = $(".search-form #searchpageinput").val();
        if (term != "") {


            window.location.href = url + "?keyword=" + encodeURIComponent(term);
        }

    })
    $(".search-form #searchpageinput").keypress(function (e) {
        if (e.which == 13) {
            var url = [location.protocol, '//', location.host, location.pathname].join('');
            var term = $(".search-form #searchpageinput").val();
            if (term != "") {


                window.location.href = url + "?keyword=" + encodeURIComponent(term);
            }

            return false;
        }
    })
    $(".search-form #landingSearch").click(function () {
        var path = $(this).attr("data-searchurl");
        var url = [location.protocol, '//', location.host, path].join('');
        var term = $(".search-form #search").val();
        if (term != "") {

            History.pushState({ keyword: term }, $("head title").text(), "?keyword=" + term);
            window.location.href = url + "?keyword=" + encodeURIComponent(term);
        }
    })

    $(".search-form #search").keypress(function (e) {
        if (e.which == 13) {
            var path = $(".search-form #landingSearch").attr("data-searchurl");
            var url = [location.protocol, '//', location.host, path].join('');
            var term = $(".search-form #search").val();
            if (term != "") {

                History.pushState({ keyword: term }, $("head title").text(), "?keyword=" + term);
                window.location.href = url + "?keyword=" + encodeURIComponent(term);
            }

            return false;
        }
    })
    $(".form-results__keyword.keyword-field").click(function () {
        var url = [location.protocol, '//', location.host, location.pathname].join('');
        url = url.substring(0, url.lastIndexOf('/'));
        window.location.href = url;
    })
});